import { ProductType } from '@/__generated__/graphql/types';

const PRODUCT_TYPES = new Set<string>(Object.values(ProductType));

export const isProductType = (value: string): value is ProductType =>
  PRODUCT_TYPES.has(value);

type TProductRouteLoaderArgs = {
  params: {
    product?: string;
  };
};

/**
 * Loader compartido por las dos ramas del árbol de rutas de Comunicaciones
 * (`__with-sidebar` y pantalla completa). Es el MISMO módulo importado desde
 * cada `page.data.ts`, no una copia por rama.
 */
export const productRouteLoader = ({ params }: TProductRouteLoaderArgs) => {
  if (!isProductType((params.product ?? '').toUpperCase())) {
    throw new Response(null, { status: 404 });
  }

  return null;
};
